import AdminList from "../../components/admin/adminMangement/AdminList";

const AdminManagementPage = () =>{
    return(
        <>
        <AdminList/>
        </>
    )
}

export default AdminManagementPage;